import React from "react";
import logo from "../../../../assets/logo.jpeg";

import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div className="Navbar">
      <div className="row d-flex align-items-center" style={{ margin: "auto" }}>
        <div className="h-12 flex items-center gap-2">
          <img
            src={logo}
            alt="magic moments"
            className="h-full w-12 rounded-full"
          />
          <h4 className="font-semibold my-1 text-[#fff]">Magic Moments</h4>
        </div>
        <div className="col-md-7 navbar-list">
          <ul className="d-flex justify-content-around "></ul>
        </div>
        <div className="col-md-1 toolsbar">
          <div className="expand-btn-inner dots">
            <ul className="d-flex justify-content-around">
              <li>
                <div id="nav-expander" className="humburger nav-expander">
                  <li>
                    <Link to="/login">
                      <div className="bg-[#fff] px-4 py-2 rounded-lg font-semibold text-xl">Login</div>
                    </Link>
                  </li>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
